var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-checkbox',{attrs:{"size":_vm.size},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }